import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../../app-context';
import IForm from '../../../../components/i-form/i-form.component';
import ITextField from '../../../../components/text-component/textfield/i-textfield.component';
import { isNotNull } from '../../../common/util.services';
import { getUserById, saveUser } from '../../user.services';
import './user-form.component.scss';
import IDropdown from '../../../../components/text-component/dropdown/i-dropdown.component';
import ICheckbox from '../../../../components/checkbox/i-checkbox.component';

const UserForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Employee');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const [customerData, setCustomerData] = useState<any>();
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (isNotNull(rowId)) {
      getUserById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Employee');
          setCustomerData(response.data);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const onSubmit = (data: any) => {
    saveUser(data, appContext,
      (response: any) => {
        navigate('/user/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} alignItems='center'>
      <Grid xs={3}>
        <ITextField name='name' label='Name' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='userId' label='Mobile Number' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='password' label='Password' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='lfhMailId' label='LFH Mail Id' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='gmailId' label='Gmail Id' required={true} />
      </Grid>
      <Grid xs={3}>
        <IDropdown name='role' label='Role' required={true} itemList={['ADMIN', 'AMZUSER', 'AMZUSEREDIT', 'LFHADMIN', 'USER']}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='designation' label='Designation' required={true}/>
      </Grid>
      <Grid xs={3}>
        <IDropdown name='isActive' label='Is Active' required={true} itemList={[0, 1]}/>
      </Grid>
      <Grid xs={3}>
        <IDropdown name='savePassword' label='Save Password' required={true} itemList={['No', 'Yes']}/>
      </Grid>
      <Grid xs={1}>
        <ICheckbox name='isCosting' label='Costing' defaultChecked={customerData.isCosting}/>
      </Grid>
      <Grid xs={1}>
        <ICheckbox name='isOrder' label='Order' defaultChecked={customerData.isOrder}/>
      </Grid>
      <Grid xs={1}>
        <ICheckbox name='isSupervision' label='Supervision' defaultChecked={customerData.isSupervision}/>
      </Grid>
      <Grid xs={1.5}>
        <ICheckbox name='isGeneralTask' label='General Task' defaultChecked={customerData.isGeneralTask}/>
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={customerData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default UserForm;